/**
 * av-hero.js
 * Three small, section-scoped enhancements:
 *  1. Respects prefers-reduced-motion by pausing any autoplaying hero video
 *     (CSS alone cannot pause a <video>).
 *  2. Falls back from video to the section's poster image if the video
 *     element ever fires an `error` event (e.g. unsupported format/network
 *     failure), so visitors never see a broken player.
 *  3. Smoothly scrolls the two hero CTAs to the Expressions and Variant
 *     Selector section roots, while respecting reduced-motion preferences.
 * Idempotent per section instance via a WeakSet guard.
 */
(function () {
  var initialized = new WeakSet();

  function initHero(hero) {
    if (!hero || initialized.has(hero)) return;
    initialized.add(hero);

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scrollButtons = hero.querySelectorAll('[data-av-scroll-target]');

    scrollButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        var selector = button.dataset.avScrollTarget;
        var target = selector ? document.querySelector(selector) : null;
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    var videos = hero.querySelectorAll('.av-hero__video');

    videos.forEach(function (video) {
      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
      }

      video.addEventListener('error', function () {
        var poster = video.getAttribute('poster');
        if (poster) {
          var img = document.createElement('img');
          img.src = poster;
          img.className = video.className;
          img.alt = '';
          video.replaceWith(img);
        } else {
          video.closest('.av-hero__media-layer')?.remove();
        }
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.av-hero').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
